module.exports = __webpack_public_path__ + "static/media/physical activity.6790e8e9.jpg";